
<Modal
  modalType="EditBoardMetadata"
  mayCancel="false"
  v-on:done="onDone"
  verticalAlign="flex-start"
>
  <h2>Enter your name</h2>
  <form v-on:submit.prevent="onDone">
    <p>
      <input ref="nameField" type="text" v-model="username" />
    </p>

    <div class="BottomRow">
      <button
        class="WBMBigButton m-primary"
        :disabled="maySubmit"
        type="submit"
      >
        Save
      </button>
      <a class="WBMBigButton" v-bind:href="loginURL">Log in</a>
    </div>
  </form>
</Modal>
